/**
 * This is a callback method which is responsible for making fine adjustments to the generic MySsFilterParams
 * builded by 'adaptQueryParams' method.
 * @param {any} mySsFilterParamsResult
 * @returns {IPaymentSlipsFilterParams} paymentSlipsFilterParams
 */
export function preparePaymentSlipListFilterParams_v2(
  mySsFilterParamsResult: any,
) {
  const result = {
    ...mySsFilterParamsResult,
    dueDateStart: mySsFilterParamsResult.dateStart ?? undefined,
    dueDateEnd: mySsFilterParamsResult.dateEnd ?? undefined,
    paymentDateStart: mySsFilterParamsResult.paymentDateStart ?? undefined,
    paymentDateEnd: mySsFilterParamsResult.paymentDateEnd ?? undefined,
    filteredField:
      PAYMENT_SLIP_FILTERED_FIELD_OPTIONS_ENUM[
        mySsFilterParamsResult.filteredField as keyof typeof PAYMENT_SLIP_FILTERED_FIELD_OPTIONS_ENUM
      ],
    productType:
      PAYMENT_SLIP_PRODUCT_TYPE_ENUM[
        mySsFilterParamsResult.productType as keyof typeof PAYMENT_SLIP_PRODUCT_TYPE_ENUM
      ],
  };

  delete result.dateStart;
  delete result.dateEnd;

  delete result.paymentDate;

  return removeEmptyFields<any>(...Object.keys(result))(result);
}
